<template>
  
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">


    <download-excel
    :fetch           = "fetchData"
    :fields          = "json_fields"
    worksheet="My Worksheet"
    :name="params.data.campaign_code + '.xls'"
    type="xls"
  >

 
     <feather-icon
      v-if="
        $route.name == 'list-more-field'"
      icon="EyeIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="showCampaignSelectedFields"
    />
     <feather-icon
      v-if="
        $route.name == 'list-more-field'"
      icon="EditIcon"
      svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
      @click="updateCampaignSelectedFields"
    />



    
    <feather-icon
    v-if="
      $route.name == 'list-more-field'"
    icon="DownloadIcon"
    svgClasses="mr-3 h-5 w-5 hover:text-danger cursor-pointer"
  />
   
    </download-excel>

    </div>
</template>

<script>
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import JsonExcel from "vue-json-excel";

export default {
  name: "CellRendererActions",
  components: {
    downloadExcel: JsonExcel,
  },
  data() {
    return {
    json_fields: {
      "Field Id": {
        field: "uuid",
        callback: (value) => {
          return `_${value.replaceAll("-", "_")}`;
        },
      },
      "Field Name": "name",
      "Field Type": "field_type",
        Type: "type"
      
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
      selected_account: null,
      abilities: null,

    };
  },
  methods: {
    showCampaignSelectedFields() {
      this.$parent.$parent.showCampaignSelectedFields(this.params.data);
    },
    updateCampaignSelectedFields() {
      this.$parent.$parent.updateCampaignSelectedFields(this.params.data);
    },

    async fetchData(){



         if (this.params.context == 'SelectedFieldsofCampaigns'){


          const response = await axios
        .get(`/api/fields/all_campaign_fields_for_export/${this.params.data.campaign_id}`)

        if (JSON.parse(response.data).length == 0) {
          this.$vs.notify({
            color: "danger",
            title: "No Fields",
            text: "There are no fields to export"
          });
          return;
        }

      return JSON.parse(response.data);

         }

       

     
    },
   
  },
  beforeMount() {},
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });


 
  }
};
</script>
